import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import { IoCloseCircleOutline } from "react-icons/io5";

ChartJS.register(ArcElement, Tooltip, Legend);

const WeeklyRevenuePaiChart = () => {
  const [data, setData] = useState({});
  const [selectedWeek, setSelectedWeek] = useState("");
  const [loading, setLoading] = useState(false);

  const [dataper, setDataPer] = useState({});
  const [selectedWeekper, setSelectedWeekPer] = useState("");

  // useEffect(() => {
  //   setLoading(true);
  //   performRequest("GET", "/incentive/getRevenueSalesPersonGenratedWeekly")
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setData(res?.data?.pieChartWeeklyRevenue);
  //         const firstWeek = Object.keys(res?.data?.pieChartWeeklyRevenue)[0];
  //         if (firstWeek) setSelectedWeek(firstWeek);
  //       } else {
  //         Toast("error", "Error while getting data!");
  //       }
  //     })
  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     })
  //     .finally(() => setLoading(false));
  // }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/incentive/getRevenueSalesPersonGenratedWeekly")
      .then((res) => {
        if (res.status === 200) {
          const weeklyData = res?.data?.pieChartWeeklyRevenue;
          setData(weeklyData);

          // Get current week number
          const now = new Date();
          const date = now.getDate();
          const startDay = new Date(
            now.getFullYear(),
            now.getMonth(),
            1
          ).getDay();
          const currentWeekNum = Math.ceil((date + startDay) / 7);
          const currentWeekLabel = `Week-${currentWeekNum}`;

          // Set selected week to current if available
          if (weeklyData[currentWeekLabel]) {
            setSelectedWeek(currentWeekLabel);
          } else {
            const firstWeek = Object.keys(weeklyData)[0];
            if (firstWeek) setSelectedWeek(firstWeek);
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch(CustomErrorResponse)
      .finally(() => setLoading(false));
  }, []);

  // useEffect(() => {
  //   setLoading(true);
  //   performRequest(
  //     "GET",
  //     "/incentive/getTotalWeekRevenueGenratedWeeklypercentage"
  //   )
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setDataPer(res?.data?.pieChartWeeklyRevenue);
  //         const firstWeek = Object.keys(res?.data?.pieChartWeeklyRevenue)[0];
  //         console.log(firstWeek);
  //         if (firstWeek) setSelectedWeekPer(firstWeek);
  //       } else {
  //         Toast("error", "Error while getting data!");
  //       }
  //     })
  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     })
  //     .finally(() => setLoading(false));
  // }, []);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      "/incentive/getTotalWeekRevenueGenratedWeeklypercentage"
    )
      .then((res) => {
        if (res.status === 200) {
          const weeklyData = res?.data?.pieChartWeeklyRevenue;
          setDataPer(weeklyData);

          // Get current week number
          const now = new Date();
          const date = now.getDate();
          const startDay = new Date(
            now.getFullYear(),
            now.getMonth(),
            1
          ).getDay();
          const currentWeekNum = Math.ceil((date + startDay) / 7);
          const currentWeekLabel = `Week-${currentWeekNum}`;

          // Set selected week to current if available
          if (weeklyData[currentWeekLabel]) {
            setSelectedWeekPer(currentWeekLabel);
          } else {
            const firstWeek = Object.keys(weeklyData)[0];
            if (firstWeek) setSelectedWeekPer(firstWeek);
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch(CustomErrorResponse)
      .finally(() => setLoading(false));
  }, []);

  const handleWeekChange = (event) => {
    setSelectedWeek(event);
  };

  const handleWeekChange2 = (event) => {
    setSelectedWeekPer(event);
  };

  const PRODUCT_LABELS = {
    "practical training": "Farm Training",
    "physical site inspection": "Physical Site Inspection",
    "hydroponic masterclass": "Hydroponic Masterclass",
    allother: "Allother",
    "site inspection kit": "Site Inspection Kit",
    "aif project report": "Aif Project Report",
  };

  const chartData = {
    labels: data[selectedWeek]?.map((entry) => entry.name) || [],
    datasets: [
      {
        label: "Revenue Share",
        data: data[selectedWeek]?.map((entry) => entry.value) || [],
        rawAmounts: data[selectedWeek]?.map((entry) => entry.rawAmount) || [],
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            const percentage = context.raw;
            const amount = context.dataset.rawAmounts[context.dataIndex];

            return `Revenue Share: ₹${amount} (${percentage}%)`;
          },
        },
      },
    },
  };

  const chartData2 = {
    labels:
      dataper[selectedWeekper]?.map(
        (entry) => PRODUCT_LABELS[entry.name] || entry.name
      ) || [],

    datasets: [
      {
        label: "Revenue Share",
        data: dataper[selectedWeekper]?.map((entry) => entry.value) || [],
        rawAmounts:
          dataper[selectedWeekper]?.map((entry) => entry.rawAmount) || [],
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options2 = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            const percentage = context.raw;
            const amount = context.dataset.rawAmounts[context.dataIndex];

            const formattedAmount = new Intl.NumberFormat("en-IN").format(
              amount
            );

            return `Revenue Share: ₹${formattedAmount} (${percentage}%)`;
          },
        },
      },
    },
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <>
      <div className="container py-4 ">
        <div className="row g-3">
          <div className="col-12 col-md-6">
            <h1 className="text-center">Sales Person Contribution </h1>
            <hr></hr>
            <p className="text-center fs-1">
              This graph illustrates the individual contributions of each sales
              representative on a weekly basis. This insight helps in
              recognizing achievements, setting targets, and offering support or
              training where needed to boost overall team performance.
            </p>
            <div className="card p-0 m-0">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="subheader"> Select Week: {selectedWeek}</div>
                  <div className="ms-auto lh-1">
                    <div className="dropdown">
                      <a
                        className="dropdown-toggle text-secondary"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      ></a>
                      <div className="dropdown-menu dropdown-menu-end">
                        {Object.keys(data).map((week) => (
                          <a
                            className="dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              handleWeekChange(week);
                            }}
                            key={week}
                          >
                            {week}
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-0 m-0">
              <div
                className="p-3 rounded d-flex flex-column justify-content-center align-items-center"
                style={{
                  height: "50vh", // 50% of the viewport height on small screens
                  maxHeight: "600px", // Max height for large screens
                  width: "100%", // Full width of the column
                }}
              >
                {selectedWeek &&
                data[selectedWeek] &&
                data[selectedWeek].length > 0 ? (
                  <Pie data={chartData} options={options} />
                ) : (
                  <>
                    <IoCloseCircleOutline style={{ fontSize: "60px" }} />
                    <br></br>
                    <div className="d-flex flex-coloumn justify-content-center align-items-center ">
                      <h2 className="">
                        No data available for the selected week.
                      </h2>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Pie Chart - full width on small, right side on medium+ */}
          <div className="col-12 col-md-6">
            <h1 className="text-center">Weekly Revenue In Percentage</h1>
            <hr></hr>
            <p className="text-center fs-1">
              This feature indicates the weekly revenue generated by each
              product in percentage. It calculates the total earnings for every
              product over the course of a week and displays the data in a
              graph, helping users visually analyze product performance and
              identify sales trends.
            </p>
            <div className="card p-0 m-0">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="subheader">
                    {" "}
                    Select Week: {selectedWeekper}
                  </div>
                  <div className="ms-auto lh-1">
                    <div className="dropdown">
                      <a
                        className="dropdown-toggle text-secondary"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      ></a>
                      <div className="dropdown-menu dropdown-menu-end">
                        {Object.keys(dataper).map((week) => (
                          <a
                            className="dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              handleWeekChange2(week);
                            }}
                            key={week}
                          >
                            {week}
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-0 m-0">
              <div
                className="p-3 rounded d-flex flex-column justify-content-center align-items-center"
                style={{
                  height: "50vh", // 50% of the viewport height on small screens
                  maxHeight: "600px", // Max height for large screens
                  width: "100%", // Full width of the column
                }}
              >
                {selectedWeekper &&
                dataper[selectedWeekper] &&
                dataper[selectedWeekper].length > 0 ? (
                  <Pie data={chartData2} options={options2} />
                ) : (
                  <>
                    <IoCloseCircleOutline style={{ fontSize: "60px" }} />
                    <br></br>
                    <div className="d-flex flex-coloumn justify-content-center align-items-center ">
                      <h2 className="">
                        No data available for the selected week.
                      </h2>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WeeklyRevenuePaiChart;
